module.exports = __webpack_public_path__ + "img/Stan Cooke.8953c5df.jpg";